var React = require('react');

function GuideNav (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M32 5V3H0v2h24v6H0v2h6v6H0v2h15v6H0v2h32v-2H17v-6h15v-2H8v-6h24v-2h-6V5z"}));
}

GuideNav.defaultProps = {"viewBox":"0 0 32 32","fillRule":"evenodd","id":"ki-guide-nav"};

module.exports = GuideNav;

GuideNav.default = GuideNav;
